import { render, staticRenderFns } from "./c-star.vue?vue&type=template&id=285ebb94&scoped=true&"
import script from "./c-star.vue?vue&type=script&lang=js&"
export * from "./c-star.vue?vue&type=script&lang=js&"
import style0 from "./c-star.vue?vue&type=style&index=0&id=285ebb94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285ebb94",
  null
  
)

export default component.exports